function shopliftTest() {
  const hypothesisID = "2be3baa0-d4a0-4688-b391-91c157ea7702"; //the shopplift test ID
  window.shoplift.isHypothesisActive(hypothesisID).then((active) => {
    console.log("SHOPLIFT:: checking hypothesis status");

    if (active) {
      console.log("SHOPLIFT:: Active");
      const applyCarouselClass = () => {
        const sideCart = document.getElementById("sidebar-cart");
        if (sideCart) {
          sideCart.classList.add("carousel");
          observer.disconnect();
        }
      };

      const observer = new MutationObserver(() => {
        applyCarouselClass();
      });

      observer.observe(document.documentElement, { childList: true, subtree: true });

      // In case the element already exists
      applyCarouselClass();
    }
  });
}

shopliftTest();
